import { cx } from 'flairup'

import { darkMode, stylesheet } from '../../../Stylesheet/stylesheet'
import { useClearSearch } from '../../../hooks/useFilter'
import { Button } from '../../atoms/Button'

import SVGClear from './svg/clear-icon.svg'
import { useSearchInputRef } from '../../context/ElementRefContext'

export function BtnClearSearch() {
  const clearSearch = useClearSearch()
  const SearchInputRef = useSearchInputRef()

  const hasValue = !!SearchInputRef?.current?.value

  return (
    <Button
      className={cx(styles.btnClearSearch, hasValue ? '' : 'opacity-50')}
      onClick={clearSearch}
      aria-label="Clear"
      title="Clear"
    >
      <div className={cx(styles.icnClearSearch)}>
        <img src={SVGClear} alt="clear" />
      </div>
    </Button>
  )
}

const HoverDark = {
  ':hover': {
    '> .epr-icn-clear-search': {},
  },
}

const styles = stylesheet.create({
  btnClearSearch: {
    '.': 'epr-btn-clear-search',
    position: 'absolute',
    right: '-40px',
    height: '30px',
    width: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    top: '50%',
    transform: 'translateY(-50%)',
    padding: '0',
    borderRadius: '50%',
  },
  icnClearSearch: {
    '.': 'epr-icn-clear-search',
    height: '20px',
    width: '20px',
  },

  ...darkMode('btnClearSearch', HoverDark),
})
